import { render, staticRenderFns } from "./ClinicBusinessCF.vue?vue&type=template&id=20862c3a&scoped=true"
import script from "./ClinicBusinessCF.vue?vue&type=script&lang=js"
export * from "./ClinicBusinessCF.vue?vue&type=script&lang=js"
import style0 from "./ClinicBusinessCF.vue?vue&type=style&index=0&id=20862c3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20862c3a",
  null
  
)

export default component.exports